
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M34.843 37.5c-.479.48-1.05.857-1.68 1.108l-8.838 3.542a5.066 5.066 0 01-5.392-1.105 5 5 0 01-1.108-5.392l3.533-8.833a5.02 5.02 0 011.11-1.683l14.717-14.72a.628.628 0 00-.435-1.067H8.42a7.795 7.795 0 00-7.795 7.795v34.412A7.792 7.792 0 008.42 59.35h34.413a7.79 7.79 0 007.792-7.793V23.235a.626.626 0 00-1.065-.442L34.842 37.5z","fill":"#FE9500"}}),_c('path',{attrs:{"d":"M46.42 8.25a1.285 1.285 0 00-1.767 0L25.12 27.785c-.12.12-.214.263-.277.42l-3.535 8.84a1.25 1.25 0 00.277 1.35 1.299 1.299 0 001.348.275l8.837-3.535c.157-.063.3-.157.42-.277l19.535-19.533a1.25 1.25 0 000-1.768L46.42 8.25zm11.493.885a5 5 0 000-7.07 5.12 5.12 0 00-7.07 0L48.19 4.718c-.039.05-.074.102-.105.157a1.226 1.226 0 00-.263.725 1.249 1.249 0 00.368.885l5.31 5.302a1.207 1.207 0 001.623.098c.05-.029.099-.061.145-.098l2.645-2.652z","fill":"#FE9500"}})])
          )
        }
      }
    